/** Default rows per page for paginated lists and tables. */
export const DEFAULT_PAGE_SIZE = 10;

/** Selectable rows-per-page options for paginated lists and tables. */
export const PAGE_SIZE_OPTIONS: readonly number[] = [10, 25, 50, 100];

/** Loading skeletons never draw more rows than this, however large the selected page size is. */
export const SKELETON_MAX_ROWS = 10;
